module.exports = __webpack_public_path__ + "static/img/sec1-slide02@tw.21d323d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezwel-renewal/sec1-slide02@tw.jpg
// module id = eXjy
// module chunks = 0